export default "__VITE_ASSET__cKubZhSz__"